<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    required: true,
  },
  icon: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'slate',
    validator: value =>
      [
        'slate',
        'blue',
        'teal',
        'amber',
        'ruby',
        'green',
        'yellow',
        'red',
      ].includes(value),
  },
});

const colorClasses = {
  slate: 'bg-n-alpha-2 text-n-slate-11',
  blue: 'bg-n-blue-3 text-n-blue-11',
  teal: 'bg-n-teal-3 text-n-teal-11',
  green: 'bg-n-teal-3 text-n-teal-11',
  amber: 'bg-n-amber-3 text-n-amber-11',
  yellow: 'bg-n-amber-3 text-n-amber-11',
  ruby: 'bg-n-ruby-3 text-n-ruby-11',
  red: 'bg-n-ruby-3 text-n-ruby-11',
};

const iconColorClass = colorClasses[props.color] || colorClasses.slate;
</script>

<template>
  <div
    class="flex items-center gap-4 p-5 rounded-2xl bg-n-solid-2 shadow outline-1 outline outline-n-container"
  >
    <div
      v-if="icon"
      class="flex items-center justify-center size-12 rounded-xl"
      :class="[iconColorClass]"
    >
      <Icon :icon="icon" class="size-6" />
    </div>
    <div class="flex-1 min-w-0">
      <p class="text-sm text-n-slate-11 truncate">{{ title }}</p>
      <p class="text-2xl font-semibold text-n-slate-12 tabular-nums">
        {{ value }}
      </p>
    </div>
  </div>
</template>
